import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

import {
  GET_SCHEDULED_STREAMS,
  GET_SCHEDULED_STREAM,
  CREATE_SCHEDULED_STREAM,
  UPDATE_SCHEDULED_STREAM,
  DELETE_SCHEDULED_STREAM,
  SIGN_UP_FOR_STREAM,
} from './constants';

import {
  getScheduledStreamsSuccess,
  getScheduledStreamsError,
  getScheduledStreamSuccess,
  getScheduledStreamFailure,
  createScheduledStreamSuccess,
  createScheduledStreamFailure,
  updateScheduledStreamSuccess,
  updateScheduledStreamFailure,
  deleteScheduledStreamSuccess,
  signUpForStreamSuccess,
  signUpForStreamError,
} from './actions';
import { normalizeError } from '../../helpers/utils';

// GET all scheduled streams
function* getScheduledStreams({ params = {} }) {
  try {
    const response = yield call(axios.get, '/api/scheduled-stream', {
      params: {
        ...params, // Spread other params if needed
        isCompleted: false, // Force filter to exclude completed streams
      },
    });

    yield put(getScheduledStreamsSuccess(response.data));
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
    yield put(getScheduledStreamsError(errors));
  }
}

// GET single stream
function* getScheduledStream({ id }) {
  try {
    const response = yield call(axios.get, `/api/scheduled-stream/${id}`);
    yield put(getScheduledStreamSuccess(response.data));
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
    yield put(getScheduledStreamFailure(errors));
  }
}

// CREATE stream
function* createScheduledStream({ data, callback }) {
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
  };

  try {
    const response = yield call(
      axios.post,
      '/api/scheduled-stream',
      JSON.stringify(data),
      config
    );
    yield put(createScheduledStreamSuccess(response.data));
    if (callback) callback(response.data);
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
    yield put(createScheduledStreamFailure(errors));
  }
}

// UPDATE stream
function* updateScheduledStream({ id, callback }) {
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
  };

  try {
    const response = yield call(
      axios.put,
      `/api/scheduled-stream/${id}`,
      {},
      config
    );
    yield put(updateScheduledStreamSuccess(response.data));
    if (callback) callback(response.data);
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
    yield put(updateScheduledStreamFailure(errors));
  }
}

function* signUpForStream({ streamId, callback }) {
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      'x-auth-token': token,
    },
  };

  try {
    const response = yield call(
      axios.put,
      `/api/scheduled-stream/${streamId}/signup`,
      {},
      config
    );

    yield put(signUpForStreamSuccess(response.data));

    if (callback) callback(response.data);
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
    yield put(signUpForStreamError(errors));
  }
}

// DELETE stream
function* deleteScheduledStream({ id, callback }) {
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      'x-auth-token': token,
    },
  };

  try {
    yield call(axios.delete, `/api/scheduled-stream/${id}`, config);
    yield put(deleteScheduledStreamSuccess(id));
    if (callback) callback(id);
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
  }
}

export default function* scheduledStreamsSaga() {
  yield takeLatest(GET_SCHEDULED_STREAMS, getScheduledStreams);
  yield takeLatest(GET_SCHEDULED_STREAM, getScheduledStream);
  yield takeLatest(CREATE_SCHEDULED_STREAM, createScheduledStream);
  yield takeLatest(UPDATE_SCHEDULED_STREAM, updateScheduledStream);
  yield takeLatest(DELETE_SCHEDULED_STREAM, deleteScheduledStream);
  yield takeLatest(SIGN_UP_FOR_STREAM, signUpForStream);
}
